import IconButton from '@alltrails/denali/components/IconButton';
import useToggle from '@alltrails/core/hooks/useToggle';
import Close from '@alltrails/denali/icons/Close';
import { useScreenLock } from '@alltrails/core';
import { ComponentProps } from 'react';
import { createPortal } from 'react-dom';
import { useIntl } from 'react-intl';
import Ad from '../Ad/Ad';
import styles from './styles.module.scss';

type Props = {
  adId: string;
  adUnitPath: ComponentProps<typeof Ad>['adUnitPath'];
  experiment: ComponentProps<typeof Ad>['experiment'];
  toggle: () => void;
};

export default function AdInterstitialPortal({ adId, adUnitPath, experiment, toggle }: Props) {
  const intl = useIntl();
  const [displayPortal, toggleDisplayPortal] = useToggle();

  useScreenLock(true);

  const adInterstitial = global.document.getElementById('ad-interstitial');

  if (!adInterstitial) {
    const div = global.document.createElement('div');
    div.setAttribute('id', 'ad-interstitial');
    const { body } = global.document;
    body.appendChild(div);
  }

  return createPortal(
    <div className={styles.container} style={{ display: !displayPortal ? 'none' : undefined }}>
      <IconButton
        icon={{ Component: Close }}
        testId="ad-interstitial-close"
        title={intl.formatMessage({ defaultMessage: 'Close' })}
        className={styles.close}
        onClick={toggle}
        size="md"
        variant="flat"
      />
      <Ad adUnitPath={adUnitPath} buttonClassName={styles.button} experiment={experiment} id={adId} onDisplay={toggleDisplayPortal} />
    </div>,
    // This should always exist based on the code above
    document.getElementById('ad-interstitial')!
  );
}
